import Segmented from "@web-ui/components/Segmented";
import { rangeText } from "../format";
import { RANGES, rangeFor, type RangeDays } from "../range";

/**
 * The date range for everything under it (one row, above the reports): last 7, 28 or 90 days,
 * with the exact days and the clock they use. The choice is the caller's to keep (in the URL).
 * `inline` keeps the days beside the control on wide screens (a toolbar with more in its row).
 */
export function RangePicker({ value, onChange, inline }: { value: RangeDays; onChange: (days: RangeDays) => void; inline?: boolean }) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <div className={inline ? "w-full max-w-sm md:w-80" : "w-full max-w-sm"}>
        <Segmented label="Date range" size="sm" options={RANGES.map((d) => ({ id: String(d), label: `${d} days` }))} value={String(value)} onChange={(id) => onChange(Number(id) as RangeDays)} />
      </div>
      <p className="text-body-2 text-t-secondary">{rangeText(rangeFor(value))} · days in UTC, compared with the {value} days before</p>
    </div>
  );
}
